var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConsultantIcon = function SvgConsultantIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#237C82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10.75 20.75-2-6h-8l2 6zm0 0h4M10.75 11.75v-.5c0-1.886 0-2.828-.586-3.414S8.636 7.25 6.75 7.25s-2.828 0-3.414.586-.586 1.528-.586 3.414v.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#237C82",
    strokeWidth: 1.5,
    d: "M17.75 11.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8.75 2.75a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#237C82",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12.75 16.25h6a2 2 0 0 1 2 2v.5a2 2 0 0 1-2 2h-1"
  })));
};
export default SvgConsultantIcon;